export default {
  CARD_TABLE_HEIGHT: "calc(100vh - 330px)",
  FRONTEND_CARD_TABLE_HEIGHT: "calc(100vh - 290px)",
  CATEGORY_LIST_HEIGHT: "height:calc(100vh - 176px)",
};
